module.exports = __webpack_public_path__ + "static/img/gzh.5799ea2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gzh.jpg
// module id = PjhA
// module chunks = 5